import { request, gql } from 'graphql-request';
import { SUBGRAPH_URL, HEADERS } from '../config/constants';

export async function fetchAllSmartWallets() {
  const query = gql`
    {
      userAccounts(first: 1000) {
        id
        owner
        account
      }
    }
  `;
  const data = await request(SUBGRAPH_URL, query, {}, HEADERS);
  if (!data || !data.userAccounts) throw new Error('No data returned from subgraph');
  return data.userAccounts;
}

export async function fetchSmartWalletsCount() {
  const query = gql`
    {
      userAccountsConnection(first: 1) {
        totalCount
      }
    }
  `;
  const data = await request(SUBGRAPH_URL, query, {}, HEADERS);
  const count = data?.userAccountsConnection?.totalCount;
  if (typeof count !== 'number') throw new Error('Failed to fetch smart wallets count');
  return count;
}

export async function fetchWalletsWithPositions() {
  const query = gql`
    {
      userAccounts(first: 1000, where: { positions_: { active: true } }) {
        id
        owner
        account
        positions(where: { active: true }) {
          nftId
          createdAt
          vault {
            id
            token0
            token1
            pool
            VaultName
          }
        }
      }
    }
  `;
  const data = await request(SUBGRAPH_URL, query, {}, HEADERS);
  if (!data || !data.userAccounts) throw new Error('No data returned from subgraph');
  return data.userAccounts;
}
